import createChangedCountEntry from '../helpers/createChangedCountEntry.js'
import isCountChanged from '../helpers/isCountChanged.js'
import isEmpty from '../helpers/isEmpty.js'
//---------------------
// track count changes
//---------------------
export default function trackCountChanges({
  change = null,
  count,
  original_counts,
  changed_counts,
  character_id,
  delete: del = false,
} = {}) {
  console.log('===================================================')
  console.log('IN trackCountChanges')
  console.log('count name = ', count.name)
  console.log('count = ', window.$deepCopy(count))
  console.log('change = ', window.$deepCopy(change))
  console.log('original_counts = ', window.$deepCopy(original_counts))
  console.log('changed_counts = ', window.$deepCopy(changed_counts))
  console.log('----------------------------------')
  //---------------------
  // check args received
  //---------------------
  if (isEmpty(count) || original_counts === undefined || changed_counts === undefined) {
    return []
  }
  /*
  -------------------------------------------------------------------------------------------------------------------------
   CHANGED ARRAY    ORIGINAL ARRAY     PARM ACTION         CHANGED ARRAY ACTION
  ---------------  ----------------   ------------         ---------------------
  A.    No               No               ADD              add (new character item)          
  B.    No               Yes              UPDATE           add existing character item update
  C.    Yes              Yes              UPDATE/REMOVE    further character item update or reverting to original)
  D.    Yes              No               ADD              update same ADD entry (further updates having flagged addition)
  -------------------------------------------------------------------------------------------------------------------------
  */
  let count_changed_parm = {}
  //------------------------------------------------------------------------------------------
  // set count name for change entry (use display name if exists - otherwise static count name)
  //------------------------------------------------------------------------------------------
  // const count_name = count.display_name ? count.display_name : count.name
  //---------------------------------------------------------------------------------
  // find count in change array (using id if existing count - or temp id for new count)
  //---------------------------------------------------------------------------------
  const changed_idx = changed_counts.findIndex((c) => (count.id != null ? c.id === count.id : null))
  console.log('XXXXX changed_idx = ', changed_idx)
  //--------------------------------------------------------------------
  // find count in original array (wont be an original entry without id)
  //--------------------------------------------------------------------
  const original_idx = original_counts.findIndex((o) => o.id === count.id)
  //=========================================================================================================================
  // A. where count NOT in change array + NOT in original array (adding new character count)
  //-----------------------------------------------------------------------------------------
  if (changed_idx == -1 && original_idx == -1) {
    console.log('A. COUNT NOT IN CHANGED OR ORIGINAL ARRAY NAME = ', count.name)
    //---------------------------
    // from characterSheetCounts
    //---------------------------
    count_changed_parm = createChangedCountEntry({
      count_name: count.name,
      id: count.id, // real or temp id used for tracking
      action: 'ADD',
      payload: {
        character: character_id ? character_id : null,
        name: count.name,
        value: count.value,
      }
    })
    changed_counts.push(count_changed_parm)
    //=========================================================================================================================
    // B. where count NOT in change array + IS in original array (deleting or updating existing character count)
    //-----------------------------------------------------------------------------------------------------------
  } else if (changed_idx == -1 && original_idx !== -1) {
    console.log('B. COUNT NOT IN CHANGED ARRAY + IS IN ORIGINAL ARRAY: ' + (count.name))
    //--------------------------------
    // where deleting character count
    //--------------------------------
    if (del) {
      console.log('B1. CREATE DELETION ENTRY')
      //--------------------
      // add deletion entry
      //--------------------
      count_changed_parm = createChangedCountEntry({
        count_name: count.name,
        action: 'DELETE',
        id: count.id, // character_count id or temp id
      })
      //------------------
      // add update entry
      //------------------
    } else {
      console.log('B2. CREATE UPDATE ENTRY')
      count_changed_parm = {
        count_name: count.name,
        action: 'UPDATE',
        id: count.id, // character_count id or temp id
        payload: {
          [change.key]: change.value,
        },
      }
    }
    changed_counts.push(count_changed_parm)
    //=========================================================================================================================
    // C. where count IS in change array + IS in original array (updating existing change entry/remove if reverted)
    //--------------------------------------------------------------------------------------------------------------
  } else if (changed_idx !== -1 && original_idx !== -1) {
    console.log('C. COUNT IS IN CHANGED ARRAY + IS IN ORIGINAL ARRAY: ' + (count.name))
    console.log('C1. CHECK IF COUNT CHANGED')
    //--------------------------------
    // where deleting character count
    //--------------------------------
    if (del) {
      console.log('C2. CREATE DELETION ENTRY')
      //---------------------------------
      // remove change entry where found
      //---------------------------------
      changed_counts.splice(changed_idx, 1)
      //--------------------
      // add deletion entry
      //--------------------
      count_changed_parm = createChangedCountEntry({
        count_name: count.name,
        action: 'DELETE',
        id: count.id, // character_count id or temp id
      })
      changed_counts.push(count_changed_parm)
      //--------------
      // not deleting
      //--------------
    } else {
      //-----------------------------------------------------------------
      // check if values changed (could have reverted back to originals)
      //-----------------------------------------------------------------
      let count_changed = isCountChanged(original_counts[original_idx], count)
      //---------------
      // value changed
      //---------------
      if (count_changed) {
        console.log('C3. COUNT VAL CHANGED - UPDATE ENTRY: ' + (count.name))
        //--------------------
        // update count entry
        //--------------------
        changed_counts[changed_idx].payload[change.key] = change.value
        //---------------------------------------
        // value is original - remove from array
        //---------------------------------------
      } else {
        console.log('C4. COUNT NOT CHANGED - REMOVE ENTRY: ' + (count.name))
        changed_counts.splice(changed_idx, 1)
      }
    }
    //=========================================================================================================================
    // D. where count IS in change array + NOT in original array (updating and add entry - further changes before commit
    //------------------------------------------------------------------------------------------------------------------
  } else {
    console.log('D. COUNT IS IN CHANGED ARRAY + NOT IN ORIGINAL ARRAY: ' + (count.name))
    //--------------------------------
    // where local count being deleted
    //--------------------------------
    if (del) {
      console.log('D1. NEW COUNT BEING DELETED - REMOVE ENTRY: ' + (count.name))
      changed_counts.splice(changed_idx, 1)
    } else {
      console.log('D2. UPDATE THE UPDATE ENTRY')
      //-------------------
      // update count entry
      //-------------------
      console.log('D3. changed_counts[changed_idx] = ', window.$deepCopy(changed_counts[changed_idx]))
      console.log('D4. change = ', change)
      changed_counts[changed_idx].payload[change.key] = change.value
    }
  }
  console.log('##################### UPDATED changed_counts = ', window.$deepCopy(changed_counts))
  console.log('===================================================')
  return changed_counts
}
